import {
    default as searchCache,
    searchSuggestionTrie,
} from 'owa-recipient-cache/lib/selectors/searchCache';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { isFeatureEnabled } from 'owa-feature-flags';

export async function getPeopleSuggestionsFromCache(
    queryString: string,
    recipientsToExclude: { EmailAddress: EmailAddressWrapper }[]
): Promise<PersonaType[]> {
    let rcTopFive = isFeatureEnabled('rp-peopleSuggestionsTrie')
        ? await searchSuggestionTrie(queryString, 5 /* numberOfResults */, recipientsToExclude)
        : searchCache(queryString, 5, recipientsToExclude);

    if (rcTopFive.length == 0) {
        return [];
    }

    let personaTypeSet = rcTopFive.map(result => {
        return {
            EmailAddress: result.EmailAddress,
            PersonaId: result.PersonaId,
            ADObjectId: result.ADObjectId,
            PersonaTypeString: result.PersonaTypeString,
        } as PersonaType;
    });

    return Promise.resolve(personaTypeSet);
}
